import api from '@utils/api';
import config from '@/config';

const positionService = {
  // Get init data (groups, etc.)
  getInit: async () => {
    return api.get(config.endpoints.positions.init);
  },

  // Get positions list with pagination
  getPositions: async (params = {}) => {
    return api.get(config.endpoints.positions.list, params);
  },

  // Get position by ID
  getPositionById: async (id) => {
    return api.get(`${config.endpoints.positions.getById}/${id}`);
  },

  // Create new position
  createPosition: async (positionData) => {
    return api.post(config.endpoints.positions.create, positionData);
  },

  // Update position
  updatePosition: async (positionData) => {
    return api.put(`${config.endpoints.positions.update}/${positionData.id}`, positionData);
  },

  // Delete position
  deletePosition: async (id) => {
    return api.delete(`${config.endpoints.positions.delete}/${id}`);
  },

  // Bulk delete positions
  bulkDeletePositions: async (ids) => {
    return api.post(`${config.endpoints.positions.delete}/bulk`, { ids });
  },
};

export default positionService;
